import * as Sentry from '@sentry/vue'
import type {App} from 'vue'

export function initSentry(app: App): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN
  if (!dsn) return

  const environment = import.meta.env.VITE_SENTRY_ENV
    || import.meta.env.VITE_APP_ENV
    || import.meta.env.MODE
  const release = import.meta.env.VITE_APP_VERSION || undefined

  Sentry.init({
    app,
    dsn,
    environment,
    release,
    sendDefaultPii: false,
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications.',
      /Loading chunk \d+ failed/,
      /Loading CSS chunk \d+ failed/,
      'ChunkLoadError',
    ],
  })
}
